import { useTranslation } from "react-i18next";
import useParamValues from "./useParamValues";

const useTranslationSetup = () => {
  const { t, i18n } = useTranslation();
  const { assessmentLang } = useParamValues();
  const activeLanguage = i18n.language;

  const setLanguage = (lang) => {
    sessionStorage.setItem("app_language", lang);
    i18n.changeLanguage(lang);
  };

  const tSubject = (key, options) => {
    if (assessmentLang === "en") {
      const enKey = `${key}_en`;
      const translated = t(enKey, options);
      if (translated !== enKey) {
        return translated;
      }
    }
    return t(key, options);
  };

  return { t, tSubject, activeLanguage, setLanguage };
};

export default useTranslationSetup;
